/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { Column, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Discount from '~/modules/ecommerceCoreUI/components/products/offers/OfferTag';
import { SmallSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import { currentCurrencyDisplayName } from '~/modules/ecommerceCore/utils/changeCurrency';
import RoundToOneDigit from '~/modules/ecommerceCore/utils/RoundToOneDigit';

import PaymentMethods from '../vendor/areas/PaymentMethods';
import ShippingMethods from '../vendor/areas/ShippingMethods';

const GiftImage = styled.div`
  display: inline-block;

  width: 55px;
  height: 50px;

  background-image: url(${props => props.image});
  background-position-x: center;
  background-position-y: center;
  background-size: contain;
  background-repeat: no-repeat;

  border-style: solid;
  border-width: ${props => props.theme.borders.size.thin}px;
  border-radius: ${props => props.theme.borders.radius.small + 1}px;
  border-color: ${props => props.theme.borders.color.light};
`;

const GiftLabel = styled.span`
  font-size: ${props => props.theme.fonts.sizes.small}px;
  color: ${props => props.theme.colors.labels.normal};
`;

const VendorDetails = (props) => {
  const getStockLabel = (stockItemsLength) => {
    if (stockItemsLength > 3) {
      return i18next.t('ecommerceCoreUI:Stock.in');
    }
    if (stockItemsLength <= 3 && stockItemsLength > 0) {
      return i18next.t('ecommerceCoreUI:Stock.only', { stockItemsLength });
    }
    return i18next.t('ecommerceCoreUI:Stock.out');
  };

  return (
    <Column fullWidth leftAligned>
      <Spacer size={1} />
      <Row spaceBetweenJustified topAligned fullWidth>
        {props.isEligibleStock && (
          <Column spaceBetween={1} leftAligned>
            {(!!props.variant?.discount || props.variant?.offer_saved_percent) && (
            <Fragment>
              <Discount offerType="hasDiscount">
                {i18next.t('ecommerceCoreUI:Product.discount')}
                {props.variant?.discount ? RoundToOneDigit(props.variant?.discount) : RoundToOneDigit(props.variant?.offer_saved_percent)}
                 %
              </Discount>
            </Fragment>
            )}
            {props.variant?.offer_saved_amount && (
            <Row spaceBetween={0.5}>
              <Label>
                {i18next.t('ecommerceCoreUI:Product.savedLabel')}
              </Label>
              <Label semiBold>
                {props.variant?.offer_saved_amount}
              </Label>
              <Label xs semiBold>
                {currentCurrencyDisplayName()}
              </Label>
            </Row>
          )}
            <Label primary sm>{getStockLabel(props.variant?.total_on_hand)}</Label>
            <PaymentMethods paymentMethods={props.variant?.vendor?.payment_methods} />
          </Column>
        )}
        {props.variant?.has_offer && props.variant?.gift_included && (
          <Column rightAligned>
            <Column fullWidth>
              <GiftImage image={props.variant?.gift_image.url_original} />
              <SmallSpacer />
              <GiftLabel>{props.variant?.gift_text}</GiftLabel>
            </Column>
            <Spacer size={0.5} />
          </Column>
        )}
      </Row>
      {(props.variant?.product_type === 'good' || props.variant?.product_type === 'offer')
      && props.isEligibleStock ? (
        <Fragment>
          <Spacer size={0.5} />
          <Separator separatorLength="full" separatorColorTone="light" />
          <Spacer size={0.5} />
          <Row>
            <ShippingMethods shippingMethods={props.variant?.vendor?.grouped_shipping_methods} />
          </Row>
        </Fragment>
        ) : undefined}
      <Spacer size={1.5} />
      {props.media.maxTablet && props.isEligibleStock && <Separator separatorLength="full" separatorColorTone="light" />}
    </Column>
  );
};

VendorDetails.defaultProps = {
  variant: {
    total_on_hand: 0,
    discount: 0,
    id: PropTypes.string,
  },
};

VendorDetails.propTypes = {
  variant: PropTypes.shape({
    discount: PropTypes.number,
    total_on_hand: PropTypes.number,
    vendor: PropTypes.shape().isRequired,
    id: PropTypes.string,
  }),
  media: PropTypes.shape({
    maxTablet: PropTypes.bool.isRequired,
  }).isRequired,
  isEligibleStock: PropTypes.bool.isRequired,
};

export default withMedia(VendorDetails);
